import React from "react";
import Modal from "../../common/components/modules/modal/Modal";
import {ModalBackButton} from "../../common/components/modules/modal/modalComponents";
import useRouter from "../../common/hooks/useRouter";
import DeliveryTypeForm from "./DeliveryTypeForm";
import useAvailableDeliveryTypes from "../hooks/useAvailableDeliveryTypes";
import {DeliveryTypes} from "../../common/models/DeliveryType";
import routes from "../../common/routes";
import useSelectPickup from "../../deliveries/hooks/useSelectPickup";
import useDeliveryAddress from "../hooks/useDeliveryAddress";
import useFeatureToggles from "../../common/hooks/useFeatureToggles";
import * as Notifications from "src/core/notifications";

function DeliveryTypeModal({isOpen, onRequestClose}) {
  const router = useRouter();
  const [availableDeliveryTypes] = useAvailableDeliveryTypes();
  const {selectStoreOrPickup} = useSelectPickup(() => {
    router.safeBack();
  });
  const goToDeliveryCheck = () => router.push(routes.deliveryCheck);
  const {DELIVERY, PICK_UP} = DeliveryTypes;
  const actions = {};
  actions[DELIVERY] = goToDeliveryCheck;
  actions[PICK_UP] = selectStoreOrPickup;

  const [address] = useDeliveryAddress();
  const toggles = useFeatureToggles();

  function isAllowedToClose() {
    return Boolean(address) || !toggles.deliveriesOnly();
  }

  const _onRequestClose = () => {
    if (isAllowedToClose()) {
      onRequestClose();
    } else {
      Notifications.error("Please select one of our delivery options.");
    }
  };

  return (
    <Modal isOpen={isOpen} closeModalOverride={_onRequestClose}>
      <ModalBackButton onClick={() => router.safeBack()} />
      <DeliveryTypeForm
        deliveryTypesList={availableDeliveryTypes}
        actionsForDeliveryType={actions}
      />
    </Modal>
  );
}

export default DeliveryTypeModal;
